import { ListGroupItem as BaseListGroupItem } from 'reactstrap';

const navigateTo = (hash) => {
    const element = document.getElementById(hash);

    if (element) {
        window.scrollTo({
            top: element.offsetTop,
            behavior: 'smooth',
        });
    }
};

export const ListGroupItem = ({ activeHash, hash, ...restProps }) => (
    <BaseListGroupItem
        active={hash === activeHash}
        onClick={() => navigateTo(hash)}
        tag="button"
        type="button"
        action
        {...restProps}
    />
);